document.addEventListener('DOMContentLoaded', function () {
    const videoWrapper = document.querySelector('.video-media');
    if (videoWrapper) {
      const videoMedia = videoWrapper.querySelector('video-media');
      if (videoMedia) {
        const img = videoMedia.querySelector('img');
        if (img) {
            const pageTitle = document.querySelector("head title")?.innerText.trim();
            if (!img.hasAttribute("alt")) {
                img.setAttribute("alt", `${pageTitle} video poster`);
                img.setAttribute("loading","lazy");
            }
        }
      }
    }
  });
  